import type {TreeStructure} from '@pb/kit-component-tree-v2';

export const DATE_RANGE_NAME = 'excel-usage-report-data-range-select';
export const REPORT_TASK = 'generate-excel-usage-report';
export const PROGRESS_LABEL = 'Generating excel plugin usage report...';
export const DATE_RANGE_OPTIONS = {
    CUSTOM: {
        value: 'custom',
        label: 'Custom',
    },
    LAST_MONTH: {
        value: 'last-month',
        label: 'Last Month',
    },
    CURRENT_LICENSE: {
        value: 'current-license',
        label: 'Current License',
    },
};

export const SELECT_NAME = 'excel-plugin-usage-report-select';
export const SELECT_OPTIONS = {
    USERS: {
        value: 'users',
        label: 'Users',
    },
    GROUPS: {
        value: 'groups',
        label: 'Group',
    },
};

export const REPORT_OPTIONS_TREE: TreeStructure = [
    {
        id: 'companySummaryReport',
        caption: 'Company Summary Report',
    },
    {
        id: 'userSummaryReport',
        caption: 'User Summary Report',
    },
    {
        id: 'userActivityTrend',
        caption: 'User Activity Trend',
    },
];
